import React, { useEffect, useState } from 'react'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import { useViewStore } from '../../Contexts/ViewContext'

interface ConversationHeaderProps {
  agentName?: string
  companyName?: string
  companyNameLocalized?: Record<string, string>
  subCompanyMessage?: string
  subCompanyMessageLocalized?: Record<string, string>
  imageUrl?: string
}

const ConversationHeader = ({
  agentName = 'Léa',
  companyName,
  companyNameLocalized,
  subCompanyMessage,
  subCompanyMessageLocalized,
  imageUrl = ''
}: ConversationHeaderProps): JSX.Element => {
  const locale = useLocaleStore((state) => state.localeForRetorikStudioContent)
  const translation = useLocaleStore((state) => state.currentTranslations)
  const themeColors = useViewStore((state) => state.themeColors)

  const [processedCompanyName, setProcessedCompanyName] = useState<string | undefined>()
  const [processedSubCompanyName, setProcessedSubCompanyName] = useState<string | undefined>()

  useEffect(() => {
    const company = companyNameLocalized?.[locale] || companyName
    const subCompany = subCompanyMessageLocalized?.[locale] ||
      subCompanyMessage

    if (company || subCompany) {
      setProcessedCompanyName(company)
      setProcessedSubCompanyName(subCompany)
    } else {
      setProcessedCompanyName('Davi')
      setProcessedSubCompanyName(`${agentName} ${translation.menu.answer}`)
    }
  }, [
    locale,
    companyName,
    companyNameLocalized,
    subCompanyMessage,
    subCompanyMessageLocalized
  ])

  return (
    <div
      id='retorik-conversation-header'
      className='rf-w-full rf-h-fit rf-grid rf-grid-cols-headerContainer rf-grid-rows-headerContainer rf-bg-truewhite rf-bg-opacity-80'
    >
      {/* Avatar */}
      <div className='rf-col-start-1 rf-col-end-2 rf-row-start-1 rf-row-end-3 rf-flex rf-items-center rf-px-2 rf-py-2'>
        <img
          src={imageUrl}
          alt='Agent'
          className='rf-w-full rf-max-h-20 rf-aspect-square rf-rounded-half rf-border-secondary rf-border-2 rf-bg-truewhite'
        />
      </div>

      {/* Agent Title + Company */}
      <div className='rf-col-start-3 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-justify-center'>
        {/* Company */}
        {processedCompanyName && (
          <div
            className='rf-font-bold rf-leading-4'
            style={{
              color: themeColors.companyName
            }}
          >
            {processedCompanyName}
          </div>
        )}

        {/* Agent Title */}
        {processedSubCompanyName && (
          <div className='rf-text-sm/4 rf-italic'>
            {processedSubCompanyName}
          </div>
        )}
      </div>
    </div>
  )
}

export default ConversationHeader
